// TODO: chore - rename me to videoDetails reducer or something
import { ContentState } from './types/reducerTypes'
import { AnyAction } from 'redux'
import { platformStoreSet } from '../../../shared/helpers'

const defaultUpNext = {
  upNextShowTitle: null,
  upNextEpisodeTitle: null,
  upNextEpisodeNumber: null,
  upNextSeasonNumber: null,
  upNextImage: null,
  upNextVideoType: null,
  upNextUrl: null,
}

const defaultState: ContentState = {
  analyticsShowTitle: '',
  id: '',
  videoDetails: {
    assetMezzanine: '',
    captionTracks: [],
    collections: [],
    content_rating: '',
    contentScope: '',
    contentType: '',
    description_long: '',
    duration: 0,
    episodeTitle: '',
    expire_date: null,
    expired: false,
    formattedOrdinals: '',
    funderMessage: '',
    hasRelated: false,
    is_mvod: null,
    isPlayable: false,
    isPlayableExplanation: [],
    legacyTpMediaId: '',
    parentShowSlug: '',
    relatedAssetUrl: '',
    relatedAssetVideoType: '',
    seconds_watched: 0,
    seriesTitle: null,
    seriesTrackingEvent: '',
    short_description: '',
    showTitle: '',
    url: null,
    drmWidevideLicenseUrl: null,
    videoId: '',
    trickPlayUrl: '',
    slug: '',
    contentUrl: '',
    parent: null,
  },
  upNext: defaultUpNext,
  upNextEnabled: true,
  upNextVideoToggled: false,
  upNextContinueWatchingTimerThresholdReached: false,
  upNextContinueWatchingModalVisible: false,
  upNextContinueWatchingBackUrl: '/',
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'SET_ANALYTICS_SHOWTITLE': //TODO: remove this and analyticsShowTitle
      return { ...state, ...action.payload }
    case 'SET_VIDEO_DATA':
      return {
        ...state,
        id: action.payload.id ?? state.id,
        videoDetails: {
          ...state.videoDetails,
          ...action.payload.videoDetails,
        },
      }
    case 'RESET_VIDEO_DATA':
      return {
        ...state,
        id: '',
        videoDetails: defaultState.videoDetails,
      }
    case 'SET_UPNEXT_DATA':
      return { ...state, upNext: action.payload } //could add this: upNextVideoToggled: false
    case 'UNSET_UPNEXT_DATA':
      return { ...state, upNext: defaultUpNext }
    case 'SET_UPNEXT_ENABLED':
      platformStoreSet('UPNEXT_ENABLED', action.payload)
      return { ...state, upNextEnabled: action.payload }
    case 'SET_UPNEXTVIDEO_TOGGLED':
      return { ...state, upNextVideoToggled: action.payload }
    case 'SET_UPNEXTCONTINUEWATCHINGTIMER_REACHED':
      return {
        ...state,
        ...action.payload,
      }
    case 'SET_UPNEXTCONTINUEWATCHINGMODAL_VISIBLE':
      return {
        ...state,
        ...action.payload,
      }
    case 'SET_UPNEXTCONTINUEWATCHING_BACKURL':
      return { ...state, ...action.payload }
    case 'SET_VIDEO_DURATION':
      return {
        ...state,
        videoDetails: {
          ...state.videoDetails,
          duration: Math.ceil(action.payload),
        },
      }
    case 'SET_VIDEO_SECONDS_WATCHED':
      return {
        ...state,
        videoDetails: {
          ...state.videoDetails,
          seconds_watched: action.payload,
        },
      }
    default:
      return state
  }
}
